import {Component, HostListener, OnInit} from '@angular/core';
import {ClickListenerService} from './shared/services/click-listener.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit {
  loggedIn = false;

  constructor(private clickListener: ClickListenerService) {}

  @HostListener('document:click', ['$event'])
  documentClick(event: Event): void {
    this.clickListener.clickedElement$.next(event.target as HTMLElement);
  }

  ngOnInit(): void {
    this.loggedIn = location.pathname !== '/';
  }
}
